/* ACL Store */

import {
  fetchACLResources,
  fetchACLPolicyGroups,
  fetchACLPolicies,
  fetchACLPolicyGroupPolicies,
  fetchACLRoles,
  fetchACLRole,
  fetchACLRoleSubordinates,
  fetchACLUsers,
  fetchACLUser,
  fetchACLUserRoles,
  fetchACLRolePolicies,
  fetchACLNavigation,
  fetchACLPagePermissions,
  createACLResource,
  createACLPolicyGroup,
  createACLPolicyGroupPolicy,
  createACLRole,
  createACLSubordinate,
  createACLUser,
  createACLUserRole,
  createACLRolePolicy,
  createACLHeader,
  createACLPage,
  createACLRolePage,
  deleteACLResource,
  deleteACLPolicyGroup,
  deleteACLPolicyGroupPolicy,
  deleteACLRole,
  deleteACLSubordinate,
  deleteACLUser,
  deleteACLUserRole,
  deleteACLRolePolicy,
  deleteACLHeader,
  deleteACLPage,
  deleteACLRolePage,
  updateACLUser
} from '@/api'

const getInitialState = () => {
  return {
    resources: [],
    policyGroups: [],
    policies: [],
    policyGroupPolicies: [],
    roles: [],
    role: {},
    subordinates: [],
    users: [],
    user: {},
    userRoles: [],
    rolePolicies: [],
    navigation: [],
    currentPagePermissions: []
  }
}

let state = getInitialState()

const actions = {
  fetchACLResources (context) {
    return fetchACLResources().then((response) => {
      context.commit('setResources', response.data)
    })
  },
  fetchACLPolicyGroups (context) {
    return fetchACLPolicyGroups().then((response) => {
      context.commit('setPolicyGroups', response.data)
    })
  },
  fetchACLPolicies (context) {
    return fetchACLPolicies().then((response) => {
      context.commit('setPolicies', response.data)
    })
  },
  fetchACLPolicyGroupPolicies (context, policyGroupId) {
    return fetchACLPolicyGroupPolicies(policyGroupId).then((response) => {
      context.commit('setPolicyGroupPolicies', response.data)
    })
  },
  fetchACLRoles (context) {
    return fetchACLRoles().then((response) => {
      context.commit('setRoles', response.data)
    })
  },
  fetchACLRole (context, roleId) {
    return fetchACLRole(roleId).then((response) => {
      context.commit('setRole', response.data)
    })
  },
  fetchACLRoleSubordinates (context, roleId) {
    return fetchACLRoleSubordinates(roleId).then((response) => {
      context.commit('setRoleSubordinates', response.data)
    })
  },
  fetchACLUsers (context) {
    return fetchACLUsers().then((response) => {
      context.commit('setUsers', response.data)
    })
  },
  fetchACLUser (context, loginId) {
    return fetchACLUser(loginId).then((response) => {
      context.commit('setUser', response.data)
    })
  },
  fetchACLUserRoles (context, loginId) {
    return fetchACLUserRoles(loginId).then((response) => {
      context.commit('setUserRoles', response.data)
    })
  },
  fetchACLRolePolicies (context, roleId) {
    return fetchACLRolePolicies(roleId).then((response) => {
      context.commit('setRolePolicies', response.data)
    })
  },
  fetchACLNavigation (context) {
    return fetchACLNavigation().then(response => {
      context.commit('setNavigation', response.data)
    })
  },
  fetchACLPagePermissions (context, pageId) {
    return fetchACLPagePermissions(pageId).then(response => {
      context.commit('setCurrentPagePermissions', response.data)
    })
  },
  createACLResource (context, payload) {
    return createACLResource(payload)
  },
  createACLPolicyGroup (context, payload) {
    return createACLPolicyGroup(payload)
  },
  createACLPolicyGroupPolicy (context, payload) {
    const policyGroupId = payload['policyGroupId']
    const policyId = payload['policyId']
    return createACLPolicyGroupPolicy(policyGroupId, policyId)
  },
  createACLRole (context, roleName) {
    return createACLRole(roleName)
  },
  createACLSubordinate (context, payload) {
    return createACLSubordinate(payload)
  },
  createACLUser (context, payload) {
    return createACLUser(payload)
  },
  createACLUserRole (context, payload) {
    return createACLUserRole(payload)
  },
  createACLRolePolicy (context, payload) {
    return createACLRolePolicy(payload)
  },
  createACLHeader (context, payload) {
    return createACLHeader(payload)
  },
  createACLPage (context, payload) {
    return createACLPage(payload)
  },
  createACLRolePage (context, payload) {
    return createACLRolePage(payload)
  },
  deleteResource (context, payload) {
    return deleteACLResource(payload)
  },
  deletePolicyGroup (context, policyGroupId) {
    return deleteACLPolicyGroup(policyGroupId)
  },
  deleteACLPolicyGroupPolicy (context, policyGroupPolicyId) {
    return deleteACLPolicyGroupPolicy(policyGroupPolicyId)
  },
  deleteACLRole (context, roleId) {
    return deleteACLRole(roleId)
  },
  deleteACLSubordinate (context, roleSubordinateId) {
    return deleteACLSubordinate(roleSubordinateId)
  },
  deleteACLUser (context, loginId) {
    return deleteACLUser(loginId)
  },
  deleteACLUserRole (context, userRoleId) {
    return deleteACLUserRole(userRoleId)
  },
  deleteACLRolePolicy (context, rolePolicyId) {
    return deleteACLRolePolicy(rolePolicyId)
  },
  updateACLUser (context, payload) {
    const loginId = payload['loginId']
    const user = payload['user']
    return updateACLUser(loginId, user)
  },
  deleteACLHeader (context, headerId) {
    return deleteACLHeader(headerId)
  },
  deleteACLPage (context, pageId) {
    return deleteACLPage(pageId)
  },
  deleteACLRolePage (context, rolePageId) {
    return deleteACLRolePage(rolePageId)
  },
  resetACLUser (context) {
    context.commit('resetACLUser')
  }
}

const mutations = {
  resetACLUser (state) {
    state.user = {}
  },
  setResources (state, payload) {
    state.resources = payload
  },
  setPolicyGroups (state, payload) {
    state.policyGroups = payload
  },
  setPolicies (state, payload) {
    state.policies = payload
  },
  setPolicyGroupPolicies (state, payload) {
    state.policyGroupPolicies = payload
  },
  setRoles (state, payload) {
    state.roles = payload
  },
  setRole (state, payload) {
    state.role = payload
  },
  setRoleSubordinates (state, payload) {
    state.subordinates = payload
  },
  setUsers (state, payload) {
    state.users = payload
  },
  setUser (state, payload) {
    const hireDate = new Date(payload.hireDate)
    const birthday = new Date(payload.birthday)
    payload.hireDate = hireDate.toISOString().substring(0, 10)
    payload.birthday = birthday.toISOString().substring(0, 10)
    state.user = payload
  },
  setRolePolicies (state, payload) {
    state.rolePolicies = payload
  },
  setUserRoles (state, payload) {
    state.userRoles = payload
  },
  setNavigation (state, payload) {
    // Build out the navigation array.
    const navigation = []
    const seen = []
    const pushed = []
    let header = {}
    for (let record of payload) {
      const headerId = record.headerId
      if (!seen.includes(headerId)) {
        header = {
          name: record.header,
          headerId: record.headerId,
          pages: []
        }
        seen.push(record.headerId)
      }
      if (record.pageId) {
        header.pages.push({
          pageId: record.pageId,
          name: record.name,
          path: record.path
        })
      }
      if (!pushed.includes(headerId)) {
        navigation.push(header)
        pushed.push(headerId)
      }
    }
    state.navigation = navigation
  },
  setCurrentPagePermissions (state, payload) {
    state.currentPagePermissions = payload
  }
}

const getters = {
  getResources (state) {
    return state.resources
  },
  getPolicyGroups (state) {
    return state.policyGroups
  },
  getPolicies (state) {
    return state.policies
  },
  getPolicyGroupPolicies (state) {
    return state.policyGroupPolicies
  },
  getRoles (state) {
    return state.roles
  },
  getUsers (state) {
    return state.users
  },
  getNavigation (state) {
    return state.navigation
  },
  getCurrentPagePermissions (state) {
    return state.currentPagePermissions
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
